<template>
    <!-- <el-aside width="230px"> -->
    <el-aside width="$store.state.isCollapsed?'64px':'200px'">
        <el-menu :collapse="$store.state.isCollapsed" :router="true" :collapse-transition="false"
            :default-active="router.fullPath">
            <el-menu-item index="/admin/index">
                <el-icon>
                    <HomeFilled />
                </el-icon>
                <span>首 页</span>
            </el-menu-item>

            <el-sub-menu index="/admin/setting">
                <template #title>
                    <el-icon>
                        <HelpFilled />
                    </el-icon>
                    <span>页面管理</span>
                </template>
                <el-menu-item index="/admin/setting/page"><el-icon>
                        <CirclePlusFilled />
                    </el-icon>图片配置</el-menu-item>
                <el-menu-item index="/admin/setting/title"><el-icon>
                        <Avatar />
                    </el-icon>标题设置</el-menu-item>
                <el-menu-item index="/admin/setting/bilibili"><el-icon>
                        <Avatar />
                    </el-icon>B站登录</el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/admin/user-manage" v-if="store.state.userInfo.role === 'admin'">
                <template #title>
                    <el-icon>
                        <HelpFilled />
                    </el-icon>
                    <span>用户管理</span>
                </template>
                <el-menu-item index="/admin/user-manage/adduser"><el-icon>
                        <CirclePlusFilled />
                    </el-icon>添加用户</el-menu-item>
                <el-menu-item index="/admin/user-manage/listuser"><el-icon>
                        <Avatar />
                    </el-icon>用户列表</el-menu-item>
            </el-sub-menu>

            <el-menu-item index="/admin/Feedback">
                <el-icon>
                    <HomeFilled />
                </el-icon>
                <span>反 馈 列 表</span>
            </el-menu-item>

            <el-sub-menu index="/admin/gift">
                <template #title>
                    <el-icon>
                        <Promotion />
                    </el-icon>
                    <span>礼 物 管 理</span>
                </template>
                <el-menu-item index="/admin/gift/list"><el-icon>
                        <List />
                    </el-icon>舰礼列表</el-menu-item>
                <el-menu-item index="/admin/gift/add"><el-icon>
                        <Briefcase />
                    </el-icon>添加舰礼</el-menu-item>
            </el-sub-menu>


            <el-sub-menu index="/admin/integral">
                <template #title>
                    <el-icon>
                        <Histogram />
                    </el-icon>
                    <span>积 分 管 理</span>
                </template>
                <el-menu-item index="/admin/integral/list"><el-icon>
                        <Management />
                    </el-icon>积分列表</el-menu-item>
                <el-menu-item index="/admin/integral/add"><el-icon>
                        <TrendCharts />
                    </el-icon>添加积分</el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/admin/shop">
                <template #title>
                    <el-icon>
                        <Histogram />
                    </el-icon>
                    <span>积 分 商 城</span>
                </template>
                <el-menu-item index="/admin/shop/list"><el-icon>
                        <Management />
                    </el-icon>商城列表</el-menu-item>
                <el-menu-item index="/admin/shop/add"><el-icon>
                        <TrendCharts />
                    </el-icon>添加商品</el-menu-item>
            </el-sub-menu>

            <el-menu-item index="/admin/Exchange">
                <el-icon>
                    <HomeFilled />
                </el-icon>
                <span>兑 换 信 息</span>
            </el-menu-item>

            <el-sub-menu index="/admin/message">
                <template #title>
                    <el-icon>
                        <Histogram />
                    </el-icon>
                    <span>匿名留言箱</span>
                </template>
                <el-menu-item index="/admin/message/list"><el-icon>
                        <Management />
                    </el-icon>留言箱列表</el-menu-item>
                <el-menu-item index="/admin/message/add"><el-icon>
                        <TrendCharts />
                    </el-icon>添加留言箱</el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/admin/song">
                <template #title>
                    <el-icon>
                        <Histogram />
                    </el-icon>
                    <span>歌 单 管 理</span>
                </template>
                <el-menu-item index="/admin/song/list"><el-icon>
                        <Management />
                    </el-icon>歌单列表</el-menu-item>
                <el-menu-item index="/admin/song/add"><el-icon>
                        <TrendCharts />
                    </el-icon>添加歌单</el-menu-item>
                <el-menu-item index="/admin/song/class"><el-icon>
                        <TrendCharts />
                    </el-icon>歌单分类管理</el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/admin/lamp">
                <template #title>
                    <el-icon>
                        <Histogram />
                    </el-icon>
                    <span>路 灯 管 理</span>
                </template>
                <el-menu-item index="/admin/lamp/list"><el-icon>
                        <Management />
                    </el-icon>路灯列表</el-menu-item>
                <el-menu-item index="/admin/lamp/add"><el-icon>
                        <TrendCharts />
                    </el-icon>添加路灯</el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/admin/black">
                <template #title>
                    <el-icon>
                        <Histogram />
                    </el-icon>
                    <span>小黑屋管理</span>
                </template>
                <el-menu-item index="/admin/black/list"><el-icon>
                        <Management />
                    </el-icon>小黑屋列表</el-menu-item>
                <el-menu-item index="/admin/black/add"><el-icon>
                        <TrendCharts />
                    </el-icon>添加小黑屋</el-menu-item>
            </el-sub-menu>

        </el-menu>
        <!-- <div style="margin-top: 90%; color: aliceblue; position: fixed; bottom: 0; left: 0; text-align: center;">
            <text href="https://beian.miit.gov.cn/" target="_blank" style="color: rgb(112, 112, 112);font-size: 11px;margin-left: 4px;">浙ICP备2024104231号</text>
        </div> -->
    </el-aside>
</template>


<script setup>
import { HomeFilled, Avatar, HelpFilled, Histogram, Promotion, CirclePlusFilled, List, Briefcase, Management, TrendCharts } from '@element-plus/icons-vue';
import { useRoute } from "vue-router";
import { useStore } from 'vuex';
import { reactive, ref } from 'vue';

const roleForm = reactive({
    roleone: false,
})
const store = useStore()
const router = useRoute()
console.log(store.state.userInfo.role);
if (store.state.userInfo.role === 'admin') {
    roleForm.roleone = true
}
const vAdmin = {
    mounted(el) {
        // console.log(el);
        // role 在数据库里是 varchar，值为 'admin'，不能和数字比较
        if (store.state.userInfo.role !== 'admin') {
            el.parentNode.removeChild(el)
        }
    }
}

</script>



<style lang="scss" scoped>
.el-aside {
    height: 100vh;

    .el-menu {
        height: 100vh;
    }
}
</style>